import { ResultBaseSubStructure } from 'domains/reports/types';

export const computePointName = (dataRow: ResultBaseSubStructure): string => {
  const val = dataRow.name?.DISPLAY_VALUE ?? '';

  return val.toString();
};
